import { useAppSelector } from "app/hooks";
import { BracketViewPicksMatchArgs } from "components/Bracket/BracketMatchArgs";
import { BracketViewer } from "components/Bracket/BracketViewer";
import { selectBracketPickOptions } from "model/Bracket/BracketPickOptions";
import { LeaderboardPart } from "model/Leaderboard/User/SegmentLeaderboardUser";
import { Pick, Pickem } from "model/Pickem/Pickem";
import { BracketemDetails } from "model/PickemDetails/Bracketem/Details";
import { Bracket } from "model/Tournament/Segment/Bracket/Bracket";
import { selectTournamentSegment } from "selectors/Tournament";
import { ErrorText } from "styles/text";

interface Props {
  bracketemDetails: BracketemDetails;
  pickem: Pickem;
  leaderboardPart: LeaderboardPart | undefined;
}
export const PickerUserBracketemPicks = ({
  bracketemDetails,
  pickem,
  leaderboardPart,
}: Props) => {
  const tournamentSegment = useAppSelector((state) =>
    selectTournamentSegment(
      state,
      bracketemDetails.tournamentId,
      bracketemDetails.segmentId
    )
  );

  if (!tournamentSegment) {
    return <ErrorText>Unable to find tournament segment</ErrorText>;
  }

  if (tournamentSegment.type === "Bracket") {
    return (
      <>
        {tournamentSegment.groups
          .filter(
            (g) =>
              !bracketemDetails.groupId ||
              g.groupId === bracketemDetails.groupId
          )
          .map((bracket) => (
            <BracketViewerInternal
              picks={pickem.picks}
              matchPoints={leaderboardPart?.points}
              bracket={bracket}
              tournamentId={bracketemDetails.tournamentId}
            />
          ))}
      </>
    );
  }

  return <ErrorText>Unsupported Segment Type</ErrorText>;
};

interface Props2 {
  picks: {
    [matchId: string]: Pick;
  };
  matchPoints:
    | {
        [matchId: string]: number;
      }
    | undefined;
  bracket: Bracket;
  tournamentId: string;
}

const BracketViewerInternal = ({
  picks,
  matchPoints,
  bracket,
  tournamentId,
}: Props2) => {
  const pickOptions = useAppSelector((state) =>
    selectBracketPickOptions(state, bracket, picks)
  );

  const bracketMatchArgs: BracketViewPicksMatchArgs = {
    picks,
    matchPoints,
    pickOptions,
  };

  return (
    <BracketViewer
      key={bracket.name}
      bracket={bracket}
      bracketMatchArgs={bracketMatchArgs}
      compact={true}
      tournamentId={tournamentId}
    />
  );
};
